import { render, staticRenderFns } from "./CartFooter.vue?vue&type=template&id=f4777434&scoped=true&"
import script from "./CartFooter.vue?vue&type=script&lang=js&"
export * from "./CartFooter.vue?vue&type=script&lang=js&"
import style0 from "./CartFooter.vue?vue&type=style&index=0&id=f4777434&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4777434",
  null
  
)

export default component.exports